export default {
  nome: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  username: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  password: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  tipoUsuario: {
    value: 'USUARIO_TOTEM',
    required: false,
    state: null
  },
  paId: {
    value: null,
    required: false,
    state: null
  },
  mesasIds: {
    value: [],
    required: false,
    state: null
  },
  midiasIds: {
    value: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/nxSenhas/totem/components/add/totem-form.js